export const getCurrencyCode = state => {
  return state.pricing.currencyCode;
};
export const getDtbId = state => {
  return state.pricing.dtbId;
};
export const getPricingState = state => state.pricing;
export const getCanComputePrices = state => Boolean(state.pricing.productData) && Boolean(state.pricing.promotions) && Boolean(state.pricing.currencyCode);